<app-dialog-wrapper
    heading="request.requestDetail.closeRequestDialog.title"
    description="request.requestDetail.closeRequestDialog.description"
    confirmLabel="request.requestDetail.closeRequestDialog.confirm"
    cancelLabel="request.requestDetail.closeRequestDialog.cancel"
    width="650px"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <form class="flex flex-col gap-4" [formGroup]="formGroup">
        <sh-editor
            formControlName="comment"
            [placeholder]="'request.requestDetail.closeRequestDialog.comment' | translate"
            class="w-full"
        ></sh-editor>
        <sh-file-input
            formControlName="attachments"
            [maxFileSizeMB]="500"
            [multiple]="true"
            class="w-full"
        ></sh-file-input>
    </form>
</app-dialog-wrapper>
